// import React, { useEffect, useState } from "react";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import {
//   format,
//   isSameDay,
//   isAfter,
//   isBefore,
//   getMonth,
//   getYear,
// } from "date-fns";
// import { useDispatch, useSelector } from "react-redux";
// import { addPickupAndDropDates } from "../../Store/dateAndTimeSlice";
// import { addEmrPickupAndDropDates } from "../../Store/emrTimeAndDateSlice";

// const CalendarSelector = ({
//   myTripPage,
//   bookingStatus = null,
//   onGetDateCount,
// }) => {
//   const isDarkMode = useSelector((store) => store.currentModeStatus.darkMode);
//   const [selectedDates, setSelectedDates] = useState([new Date(), new Date()]);
//   const [isStartSelected, setIsStartSelected] = useState(false);
//   const [activeStartDate, setActiveStartDate] = useState(new Date());
//   const dispatch = useDispatch();
//   const currentDates = useSelector(
//     (store) => store?.currentDatesAndTimings?.pickupAndDropDates
//   );

//   const currentEMRDates = useSelector(
//     (store) => store?.emrDatesAndTimings?.pickupAndDropDates
//   );

//   const handleDateClick = (date) => {
//     if (!isStartSelected || !selectedDates[0]) {
//       setSelectedDates([date]);
//       const tomorrowDate = new Date(date);
//       if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
//         tomorrowDate.setDate(tomorrowDate.getDate());
//       } else {
//         tomorrowDate.setDate(tomorrowDate.getDate() + 1);
//       }

//       const pickupDate = format(date, "MMM dd, yyyy");
//       const dropDate = format(tomorrowDate, "MMM dd, yyyy");

//       //firstly we are checking the component is from myTrip page or not
//       if (myTripPage) {
//         if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
//           dispatch(
//             addEmrPickupAndDropDates({
//               pickupDate: currentEMRDates?.pickupDate,
//               dropDate,
//             })
//           );
//         } else {
//           //if it is my trip page we are dispatching the dates to to emrDateAndtime store
//           dispatch(addEmrPickupAndDropDates({ pickupDate, dropDate }));
//         }
//       } else {
//         dispatch(addPickupAndDropDates({ pickupDate, dropDate }));
//       }
//       setIsStartSelected(true);
//     } else {
//       // Check if the newly clicked date should be the start or end date
//       if (isAfter(selectedDates[0], date)) {
//         // If the existing start date is after the new date, switch them
//         setSelectedDates([date, selectedDates[0]]);
//         const pickupDate = format(date, "MMM dd, yyyy");
//         const dropDate = format(selectedDates[0], "MMM dd, yyyy");

//         if (myTripPage) {
//           if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
//             dispatch(
//               addEmrPickupAndDropDates({
//                 pickupDate: currentEMRDates?.pickupDate,
//                 dropDate,
//               })
//             );
//           } else {
//             dispatch(addEmrPickupAndDropDates({ pickupDate, dropDate }));
//           }
//         } else {
//           dispatch(addPickupAndDropDates({ pickupDate, dropDate }));
//         }
//       } else {
//         // Otherwise, set the new date as the end date
//         setSelectedDates([selectedDates[0], date]);
//         const pickupDate = format(selectedDates[0], "MMM dd, yyyy");
//         const dropDate = format(date, "MMM dd, yyyy");
//         if (myTripPage) {
//           if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
//             dispatch(
//               addEmrPickupAndDropDates({
//                 pickupDate: currentEMRDates?.pickupDate,
//                 dropDate,
//               })
//             );
//           } else {
//             dispatch(addEmrPickupAndDropDates({ pickupDate, dropDate }));
//           }
//         } else {
//           dispatch(addPickupAndDropDates({ pickupDate, dropDate }));
//         }
//       }
//       setIsStartSelected(false); // Allow new range selection
//     }
//   };

//   const tileClassName = ({ date, view }) => {
//     if (view === "month") {
//       const activeMonth = getMonth(activeStartDate);
//       const activeYear = getYear(activeStartDate);
//       const dateMonth = getMonth(date);
//       const dateYear = getYear(date);

//       // Check if the date is in the same month and year as the active start date
//       if (dateMonth !== activeMonth || dateYear !== activeYear) {
//         return "hidden_date";
//       }

//       // Check if the date is within the selected pickup and drop dates range
//       if (myTripPage) {
//         if (
//           currentEMRDates?.pickupDate &&
//           currentEMRDates?.dropDate &&
//           isAfter(date, currentEMRDates?.pickupDate) &&
//           isBefore(date, currentEMRDates?.dropDate)
//         ) {
//           return "between-date";
//         }
//       } else {
//         if (
//           currentDates?.pickupDate &&
//           currentDates?.dropDate &&
//           isAfter(date, currentDates?.pickupDate) &&
//           isBefore(date, currentDates?.dropDate)
//         ) {
//           return "between-date";
//         }
//       }

//       //  //firstly we are checking the component is from myTrip page or not
//       // Check if the date is the pickup or drop date
//       if (myTripPage) {
//         if (
//           currentEMRDates?.pickupDate &&
//           isSameDay(date, currentEMRDates?.pickupDate)
//         ) {
//           return "selected-date";
//         }
//         if (
//           currentEMRDates?.dropDate &&
//           isSameDay(date, currentEMRDates?.dropDate)
//         ) {
//           return "selected-date";
//         }
//       } else {
//         if (
//           currentDates?.pickupDate &&
//           isSameDay(date, currentDates?.pickupDate)
//         ) {
//           return "selected-date";
//         }
//         if (currentDates?.dropDate && isSameDay(date, currentDates?.dropDate)) {
//           return "selected-date";
//         }
//       }
//     }
//   };

//   const locationTimeData = JSON.parse(
//     localStorage.getItem("allLocationsTimeZones")
//   );
//   const currentDate = locationTimeData?.timeSlots?.currentDate;

//   // Convert the currentDate string to a Date object
//   const date = new Date(currentDate + "T00:00:00"); // Ensuring midnight time for the date

//   // Format the date to match "Wed Nov 27 2024 00:00:00 GMT-0500 (Eastern Standard Time)"
//   const options = {
//     weekday: "short",
//     year: "numeric",
//     month: "short",
//     day: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     timeZoneName: "short",
//     timeZone: "America/New_York", // Set the timezone to Eastern Standard Time
//   };

//   const formattedDate = date.toLocaleString("en-US", options); // This is for display only
//   // console.log(formattedDate); // For debugging/logging

//   // For minDate, use the Date object directly
//   const minDate = date; // Use the Date object here for minDate

//   return (
//     <div>
//       <Calendar
//         onClickDay={handleDateClick}
//         value={selectedDates}
//         minDate={minDate}
//         className={`react-calendar ${
//           isDarkMode ? "darkMode" : "lightGreyMode"
//         }`}
//         tileClassName={tileClassName}
//         onActiveStartDateChange={({ activeStartDate }) =>
//           setActiveStartDate(activeStartDate)
//         }
//         showDoubleView={false}
//       />
//     </div>
//   );
// };

// export default CalendarSelector;


// import React, { useEffect, useState } from "react";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import {
//   format,
//   isSameDay,
//   isAfter,
//   isBefore,
//   getMonth,
//   getYear,
// } from "date-fns";
// import { useDispatch, useSelector } from "react-redux";
// import { addPickupAndDropDates } from "../../Store/dateAndTimeSlice";
// import { addEmrPickupAndDropDates } from "../../Store/emrTimeAndDateSlice";

// const CalendarSelector = ({
//   myTripPage,
//   bookingStatus = null,
//   onGetDateCount,
//   clearDates,
//   setClearDates = () => {},
//   clearDatesFromTimeSelector,
//   setClearDatesFromTimeSelector = () => {},
//   clearDatesFromMyTrips,
//   setClearDatesFromMyTrips = () => {}
// }) => {
//   const isDarkMode = useSelector((store) => store.currentModeStatus.darkMode);
//   const [selectedDates, setSelectedDates] = useState([new Date(), new Date()]);
//   const [isStartSelected, setIsStartSelected] = useState(false);
//   const [activeStartDate, setActiveStartDate] = useState(new Date());
//   const dispatch = useDispatch();
//   const currentDates = useSelector(
//     (store) => store?.currentDatesAndTimings?.pickupAndDropDates
//   );

//   const currentEMRDates = useSelector(
//     (store) => store?.emrDatesAndTimings?.pickupAndDropDates
//   );

//   const handleDateClick = (date) => {
//     // Case 1: If no start date is selected or we are in the start state
//     if (!isStartSelected || !selectedDates[0]) {
//       // Set the clicked date as the start date
//       setSelectedDates([date]); 
//       const pickupDate = format(date, "MMM dd, yyyy");
  
//       // Dispatch the date as the start date
//       if (myTripPage) {
//         if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
//           dispatch(
//             addEmrPickupAndDropDates({
//               pickupDate: currentEMRDates?.pickupDate,
//               dropDate: pickupDate, // Temporarily use the same date as drop date
//             })
//           );
//         } else {
//           dispatch(addEmrPickupAndDropDates({ pickupDate, dropDate: pickupDate }));
//         }
//       } else {
//         dispatch(addPickupAndDropDates({ pickupDate, dropDate: pickupDate }));
//       }
  
//       setIsStartSelected(true); // Set to start state
//     } else {
//       // Case 2: If the user selects a date after the start date (setting the end date)
//       if (isAfter(date, selectedDates[0])) {
//         setSelectedDates([selectedDates[0], date]); // Set the end date
//         const pickupDate = format(selectedDates[0], "MMM dd, yyyy");
//         const dropDate = format(date, "MMM dd, yyyy");
  
//         // Dispatch the start and end dates
//         if (myTripPage) {
//           if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
//             dispatch(
//               addEmrPickupAndDropDates({
//                 pickupDate: currentEMRDates?.pickupDate,
//                 dropDate,
//               })
//             );
//           } else {
//             dispatch(addEmrPickupAndDropDates({ pickupDate, dropDate }));
//           }
//         } else {
//           dispatch(addPickupAndDropDates({ pickupDate, dropDate }));
//         }
//       } 
//       // Case 3: If the user selects a date before the start date (reset the range)
//       else if (isBefore(date, selectedDates[0])) {
//         setSelectedDates([date]); // Set the clicked date as the new start date
//         const pickupDate = format(date, "MMM dd, yyyy");
  
//         // Dispatch only the new start date (reset the end date)
//         if (myTripPage) {
//           if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
//             dispatch(
//               addEmrPickupAndDropDates({
//                 pickupDate: currentEMRDates?.pickupDate,
//                 dropDate: pickupDate, // Temporarily use the same date as drop date
//               })
//             );
//           } else {
//             dispatch(addEmrPickupAndDropDates({ pickupDate, dropDate: pickupDate }));
//           }
//         } else {
//           dispatch(addPickupAndDropDates({ pickupDate, dropDate: pickupDate }));
//         }
  
//         setIsStartSelected(true); // Reset to start state
//       }
//     }
//   };
  

//   const tileClassName = ({ date, view }) => {
//     if (view === "month") {
//       const activeMonth = getMonth(activeStartDate);
//       const activeYear = getYear(activeStartDate);
//       const dateMonth = getMonth(date);
//       const dateYear = getYear(date);

//       // Check if the date is in the same month and year as the active start date
//       if (dateMonth !== activeMonth || dateYear !== activeYear) {
//         return "hidden_date";
//       }

//       // Check if the date is within the selected pickup and drop dates range
//       if (myTripPage) {
//         if (
//           currentEMRDates?.pickupDate &&
//           currentEMRDates?.dropDate &&
//           isAfter(date, currentEMRDates?.pickupDate) &&
//           isBefore(date, currentEMRDates?.dropDate)
//         ) {
//           return "between-date";
//         }
//       } else {
//         if (
//           currentDates?.pickupDate &&
//           currentDates?.dropDate &&
//           isAfter(date, currentDates?.pickupDate) &&
//           isBefore(date, currentDates?.dropDate)
//         ) {
//           return "between-date";
//         }
//       }

//       //  //firstly we are checking the component is from myTrip page or not
//       // Check if the date is the pickup or drop date
//       if (myTripPage) {
//         if (
//           currentEMRDates?.pickupDate &&
//           isSameDay(date, currentEMRDates?.pickupDate)
//         ) {
//           return "selected-date";
//         }
//         if (
//           currentEMRDates?.dropDate &&
//           isSameDay(date, currentEMRDates?.dropDate)
//         ) {
//           return "selected-date";
//         }
//       } else {
//         if (
//           currentDates?.pickupDate &&
//           isSameDay(date, currentDates?.pickupDate)
//         ) {
//           return "selected-date";
//         }
//         if (currentDates?.dropDate && isSameDay(date, currentDates?.dropDate)) {
//           return "selected-date";
//         }
//       }
//     }
//   };

//   const locationTimeData = JSON.parse(
//     localStorage.getItem("allLocationsTimeZones")
//   );
//   const currentDate = locationTimeData?.timeSlots?.currentDate;

//   // Convert the currentDate string to a Date object
//   const date = new Date(currentDate + "T00:00:00"); // Ensuring midnight time for the date

//   // Format the date to match "Wed Nov 27 2024 00:00:00 GMT-0500 (Eastern Standard Time)"
//   const options = {
//     weekday: "short",
//     year: "numeric",
//     month: "short",
//     day: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     timeZoneName: "short",
//     timeZone: "America/New_York", // Set the timezone to Eastern Standard Time
//   };

//   //const formattedDate = date.toLocaleString("en-US", options); // This is for display only
//   const formattedDate = format(new Date(`${currentDate}T00:00:00`), "MMM dd, yyyy");
//   const tomorrowDate = new Date(new Date(`${currentDate}T00:00:00`).setDate(new Date(`${currentDate}T00:00:00`).getDate() + 1));
//   const formattedTomorrowDate = format(tomorrowDate, "MMM dd, yyyy");
//   //console.log(formattedDate); // For debugging/logging

//   // For minDate, use the Date object directly
//   const minDate = date; // Use the Date object here for minDate

//   useEffect(() => {
//    if(clearDates || clearDatesFromTimeSelector || clearDatesFromMyTrips){
//     dispatch(addPickupAndDropDates({ pickupDate: formattedDate, dropDate: formattedTomorrowDate }));
//     setIsStartSelected(false)
//     setClearDates(false)
//     setClearDatesFromTimeSelector(false)
//     setClearDatesFromMyTrips(false)
//    }
//   }, 
//     //eslint-disable-next-line
//   [clearDates, clearDatesFromTimeSelector, clearDatesFromMyTrips])

//   return (
//     <div>
//       <Calendar
//         onClickDay={handleDateClick}
//         value={selectedDates}
//         minDate={minDate}
//         className={`react-calendar ${
//           isDarkMode ? "darkMode" : "lightGreyMode"
//         }`}
//         tileClassName={tileClassName}
//         onActiveStartDateChange={({ activeStartDate }) =>
//           setActiveStartDate(activeStartDate)
//         }
//         showDoubleView={false}
//       />
//     </div>
//   );
// };

// export default CalendarSelector;


import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  format,
  isSameDay,
  isAfter,
  isBefore,
  getMonth,
  getYear,
} from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { addPickupAndDropDates, addPickupAndDropTimings } from "../../Store/dateAndTimeSlice";
import { addEmrPickupAndDropDates } from "../../Store/emrTimeAndDateSlice";

const CalendarSelector = ({
  myTripPage,
  bookingStatus = null,
  onGetDateCount,
  clearDates,
  setClearDates = () => {},
  clearDatesFromTimeSelector,
  setClearDatesFromTimeSelector = () => {},
  clearDatesFromMyTrips,
  setClearDatesFromMyTrips = () => {}
}) => {
  const isDarkMode = useSelector((store) => store.currentModeStatus.darkMode);
  const [selectedDates, setSelectedDates] = useState([new Date(), new Date()]);
  const [isStartSelected, setIsStartSelected] = useState(false);
  const [activeStartDate, setActiveStartDate] = useState(new Date());
  const dispatch = useDispatch();
  const currentDates = useSelector(
    (store) => store?.currentDatesAndTimings?.pickupAndDropDates
  );

  const currentEMRDates = useSelector(
    (store) => store?.emrDatesAndTimings?.pickupAndDropDates
  );

  const handleDateClick = (date) => {
    if (!isStartSelected || !selectedDates[0]) {
      setSelectedDates([date]);
      const pickupDate = format(date, "MMM dd, yyyy");

      if (myTripPage) {
        if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
          dispatch(
            addEmrPickupAndDropDates({
              pickupDate: currentEMRDates?.pickupDate,
              dropDate: pickupDate, // Temporarily use the same date as drop date
            })
          );
        } else {
          dispatch(addEmrPickupAndDropDates({ pickupDate, dropDate: pickupDate }));
        }
      } else {
        dispatch(addPickupAndDropDates({ pickupDate, dropDate: pickupDate }));
      }

      setIsStartSelected(true);
    } else {
      if (isAfter(date, selectedDates[0])) {
        setSelectedDates([selectedDates[0], date]);
        const pickupDate = format(selectedDates[0], "MMM dd, yyyy");
        const dropDate = format(date, "MMM dd, yyyy");

        if (myTripPage) {
          if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
            dispatch(
              addEmrPickupAndDropDates({
                pickupDate: currentEMRDates?.pickupDate,
                dropDate,
              })
            );
          } else {
            dispatch(addEmrPickupAndDropDates({ pickupDate, dropDate }));
          }
        } else {
          dispatch(addPickupAndDropDates({ pickupDate, dropDate }));
        }
      } 
      else if (isBefore(date, selectedDates[0])) {
        setSelectedDates([date]);
        const pickupDate = format(date, "MMM dd, yyyy");

        if (myTripPage) {
          if (bookingStatus === "On-Going" || bookingStatus === "Completed") {
            dispatch(
              addEmrPickupAndDropDates({
                pickupDate: currentEMRDates?.pickupDate,
                dropDate: pickupDate,
              })
            );
          } else {
            dispatch(addEmrPickupAndDropDates({ pickupDate, dropDate: pickupDate }));
          }
        } else {
          dispatch(addPickupAndDropDates({ pickupDate, dropDate: pickupDate }));
        }

        setIsStartSelected(true);
      }
    }
  };

  const tileClassName = ({ date, view }) => {
    if (view === "month") {
      const activeMonth = getMonth(activeStartDate);
      const activeYear = getYear(activeStartDate);
      const dateMonth = getMonth(date);
      const dateYear = getYear(date);
  
      // Helper function to check if a date is between the pickup and drop dates, or selected as pickup/drop
      const checkForRangeAndSelection = (date) => {
        if (myTripPage) {
          if (
            currentEMRDates?.pickupDate &&
            currentEMRDates?.dropDate &&
            isAfter(date, currentEMRDates?.pickupDate) &&
            isBefore(date, currentEMRDates?.dropDate)
          ) {
            return "between-date";
          }
          if (currentEMRDates?.pickupDate && isSameDay(date, currentEMRDates?.pickupDate)) {
            return "selected-date";
          }
          if (currentEMRDates?.dropDate && isSameDay(date, currentEMRDates?.dropDate)) {
            return "selected-date";
          }
        } else {
          if (
            currentDates?.pickupDate &&
            currentDates?.dropDate &&
            isAfter(date, currentDates?.pickupDate) &&
            isBefore(date, currentDates?.dropDate)
          ) {
            return "between-date";
          }
          if (currentDates?.pickupDate && isSameDay(date, currentDates?.pickupDate)) {
            return "selected-date";
          }
          if (currentDates?.dropDate && isSameDay(date, currentDates?.dropDate)) {
            return "selected-date";
          }
        }
        return ""; // No special class if none of the above conditions match
      };
  
      // For dates in the active month (current month)
      if (dateMonth === activeMonth && dateYear === activeYear) {
        return checkForRangeAndSelection(date);
      }
  
      // For dates in other months, still check the range and selection logic
      return checkForRangeAndSelection(date); // Apply range and selection logic for other months as well
    }
  };
  

  const locationTimeData = JSON.parse(localStorage.getItem("allLocationsTimeZones"));
  const currentDate = locationTimeData?.timeSlots?.currentDate;

  const date = new Date(currentDate + "T00:00:00");

  const formattedDate = currentDate && format(new Date(`${currentDate}T00:00:00`), "MMM dd, yyyy");
  const tomorrowDate = currentDate && new Date(new Date(`${currentDate}T00:00:00`).setDate(new Date(`${currentDate}T00:00:00`).getDate() + 1));
  const formattedTomorrowDate = currentDate && format(tomorrowDate, "MMM dd, yyyy");

  const minDate = date;

  useEffect(() => {
    if(clearDates || clearDatesFromTimeSelector || clearDatesFromMyTrips){
      dispatch(addPickupAndDropDates({ pickupDate: formattedDate, dropDate: formattedTomorrowDate }));//this will reset to current dates
      dispatch(addPickupAndDropTimings({
      pickupTime: locationTimeData?.timeSlots?.currentDateTimeSlots[0],
      dropTime: locationTimeData?.timeSlots?.currentDateTimeSlots[0],
      }));//this will reset to current timings
      setIsStartSelected(false);
      setClearDates(false);
      setClearDatesFromTimeSelector(false);
      setClearDatesFromMyTrips(false);
    }
      //eslint-disable-next-line
  }, [clearDates, clearDatesFromTimeSelector, clearDatesFromMyTrips]);

  // Get all months
  const getMonthsInRange = () => {
    const months = [];
  
    // Get current year
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth(); // getMonth returns a 0-indexed value (0 for Jan, 1 for Feb, etc.)
    
    // Set start date to be the 1st of April of the current year
    const startDate = new Date(currentYear, currentMonth, 1); // April of current year
    
    // Set end date to be the 31st of December of the next year
    const endDate = new Date(currentYear + 3, 11, 31); // December of next year
    
    let currentDate = startDate;
    while (currentDate <= endDate) {
      months.push(new Date(currentDate)); // Add each month
      currentDate.setMonth(currentDate.getMonth() + 1); // Move to next month
    }
  
    return months;
  };

  const monthsInRange = getMonthsInRange();

  return (
    window?.innerWidth > 992 ? 
    <Calendar
    onClickDay={handleDateClick}
    value={selectedDates}
    minDate={minDate}
    className={`react-calendar ${myTripPage ? "myTripCalendarBorder" : ""} ${isDarkMode ? "darkMode" : "lightGreyMode"}`}
    tileClassName={tileClassName}
    onActiveStartDateChange={({ activeStartDate }) => setActiveStartDate(activeStartDate)}
    showDoubleView={false}
  />
    :
      <div className="scrollable-calendar-container">
      <div className="calendar-months">
        {monthsInRange.map((month, index) => (
          <div key={index} className="calendar-month">
            <div className="text-center py-1 fontSize17 fontAntarctica">{format(month, 'MMMM yyyy')}</div>
            <Calendar
              onClickDay={handleDateClick}
              value={selectedDates}
              minDate={minDate}
              className={`react-calendar ${isDarkMode ? "darkMode" : "lightGreyMode"}`}
              tileClassName={tileClassName}
              onActiveStartDateChange={({ activeStartDate }) => setActiveStartDate(activeStartDate)}
              showDoubleView={false}
              activeStartDate={new Date(month.getFullYear(), month.getMonth(), 1)} // Ensure activeStartDate is set properly for each month
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarSelector;
